// NOTE: date is in this format: YYYY-MM-DD
// Returns date in UTC time
export const formatDateISOString = (date: string) => {
	return new Date(date).toISOString();
};

// NOTE: date is in this format: YYYY-MM-DDTHH:MM:SS.SSSZ UTC
// This returns the formatted date "Mon D" keeping UTC timezone because
// that is how it was saved and is being returned and we dont want to convert
export const formatDisplayDate = (date: string) => {
	const dateObj = new Date(date);

	return dateObj.toLocaleString('en-US', {
		day: 'numeric',
		month: 'short',
		timeZone: 'UTC',
	});
};

export const formatDisplayDateWithYear = (date: string) => {
	const dateObj = new Date(date);

	return dateObj.toLocaleString('en-US', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		timeZone: 'UTC',
	});
};
